import { FormHelperText, PopperProps, SxProps, Theme } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import MyDatePicker from "../pickers/DatePicker";

interface RHFDatePickerProps {
  name: string;
  popperPlacement?: PopperProps["placement"];
  label?: string;
  rules?: any;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const RHFDatePicker = (props: RHFDatePickerProps) => {
  const { name, label, rules, disabled, sx, popperPlacement, ...other } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <MyDatePicker
              value={field.value}
              onChange={(date, event) => {
                field.onChange(date);
              }}
              label={label}
              error={!!error}
              disabled={disabled}
              sx={sx}
              popperPlacement={popperPlacement}
              {...other}
            />
            {error && (
              <FormHelperText error sx={{ textAlign: "left" }}>
                {error.message}
              </FormHelperText>
            )}
          </>
        );
      }}
    />
  );
};

export default RHFDatePicker;
